import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const downloadAgendaSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    empresa: Yup.object().nullable().required(v.requiredField('empresa', 'select')),
    especialidade: Yup.object().nullable().required(v.requiredField('especialidade', 'select')),
    data: Yup.string().nullable().required(v.requiredField('data')),
    horarioInicio: Yup.string().nullable().required(v.requiredField('horario_inicio')),
    horarioTermino: Yup.string().nullable().required(v.requiredField('horario_termino')),
  })
}
